import * as React from 'react';
import * as styles from './styles.css';

import { Header1, Header2 } from '@cian/ui-kit/typography';

import { useIsDesktop } from '../Responsive';

export interface IFiltersProps {
  region: React.ReactNode;
  dealType: React.ReactNode;
  category: React.ReactNode;
}

export function Filters({ region, dealType, category }: IFiltersProps) {
  const isDesktop = useIsDesktop();
  const Header = isDesktop ? Header1 : Header2;

  return (
    <div className={styles['container']}>
      <h2 className={styles['title']}>
        <Header>Ключевые показатели рынка недвижимости</Header>
      </h2>
      <div className={styles['filters']}>
        <div className={styles['filter-item']}>{region}</div>
        <div className={styles['filter-item']}>{dealType}</div>
        <div className={styles['filter-item']}>{category}</div>
      </div>
    </div>
  );
}
